<template>
  <a-layout class="sider-content-box">
    <a-layout-content>
      <a-menu
        theme="light"
        mode="vertical"
        :selectedKeys="[$route.path.replace(/\//g, '')]"
        class="ul-menu"
      >
        <a-menu-item :key="'index'">
          <router-link to="/home">
            <span class="anticon">
              <i class="iconfont icon-shouye menu-icon"></i>
            </span>
            <span>{{ $t(`navbar.home`) }}</span>
          </router-link>
        </a-menu-item>
        <a-menu-item :key="'shareTemplate'">
          <router-link to="/shareTemplate">
            <span class="anticon">
              <i class="iconfont icon-gongxiangmoban menu-icon"></i>
            </span>
            <span>{{ $t(`navbar.shareTemplate`) }}</span>
          </router-link>
        </a-menu-item>
        <a-menu-item :key="'cloudTemplate'">
          <router-link to="/cloudTemplate">
            <span class="anticon">
              <i class="iconfont icon-yunduanmoban menu-icon"></i>
            </span>
            <span>{{ $t(`navbar.cloudTemplate`) }}</span>
          </router-link>
        </a-menu-item>
        <a-menu-item :key="'cloudData'">
          <router-link to="/cloudData">
            <span class="anticon">
              <i class="iconfont icon-yunduanshuju menu-icon"></i>
            </span>
            <span>{{ $t(`navbar.cloudData`) }}</span>
          </router-link>
        </a-menu-item>

        <template v-if="webUrl.length > 0">
          <a-sub-menu :style="{ paddingLeft: collapsed ? '7px' : '3px' }">
            <template #icon>
              <i class="iconfont icon-zaixiangongju menu-icon"></i>
            </template>
            <template #title v-if="!collapsed">{{ $t(`navbar.onlinetool`) }}</template>
            <a-menu-item v-for="item in webUrl" :key="item.name">
              <div style="width: 100%" @click="handleOpenWeb(item)">
                {{ item.title }}
              </div>
            </a-menu-item>
          </a-sub-menu>
        </template>

        <a-sub-menu :style="{ paddingLeft: collapsed ? '7px' : '3px' }">
          <template #icon>
            <i class="iconfont icon-bangzhu menu-icon"></i>
          </template>
          <template #title v-if="!collapsed">{{ $t(`navbar.help`) }}</template>
          <a-menu-item :key="'download'" class="help-menu-item">
            <!-- hprt -->
            <div
              style="width: 100%"
              v-if="VUE_APP_VERSION == 'hprt'"
              @click="handleHereOpen('/download/')"
            >
              {{ $t(`navbar.download`) }}
            </div>
            <!-- HereLabel -->
            <router-link to="/download" target="_blank" v-else>
              <span>{{ $t(`navbar.download`) }}</span>
            </router-link>
          </a-menu-item>
          <a-menu-item :key="'helpDetail'" class="help-menu-item">
            <!-- hprt -->
            <div
              style="width: 100%"
              v-if="VUE_APP_VERSION == 'hprt'"
              @click="handleHereOpen('/helpDetail/')"
            >
              {{ $t(`navbar.help`) }}
            </div>
            <!-- HereLabel -->
            <router-link to="help" target="_blank" v-else>
              <span>{{ $t(`navbar.help`) }}</span>
            </router-link>
          </a-menu-item>
          <a-menu-item key="suggest" class="help-menu-item" @click="handleSuggest">
            <span>{{ $t(`navbar.suggest`) }}</span>
          </a-menu-item>
        </a-sub-menu>
      </a-menu>
    </a-layout-content>
    <a-layout-footer class="sider-footer">
      <a-menu
        theme="light"
        mode="vertical"
        :selectable="false"
        v-model:selectedKeys="footerSelectedKeys"
        @click="handleClick"
      >
        <a-sub-menu :key="'user'" v-if="userInfo" @click="changeUnit">
          <template #icon>
            <div>
              <img
                style="
                  width: 16px;
                  height: 16px;
                  position: absolute;
                  bottom: 12px;
                  left: 48px;
                "
                :src="
                  userMemberInfo.status == 1
                    ? require('../../../static/icon/VIPjiaobiao-active.png')
                    : require('../../../static/icon/VIPjiaobiao.png')
                "
                alt=""
              />
              <img
                v-if="userData.head_pic"
                class="user-pic"
                :src="userData.head_pic"
                alt=""
              />
              <img v-else class="user-pic" src="../../assets/avatar.png" alt="" />
            </div>
          </template>
          <template #title>{{ userData.nickname || userData.username }}</template>
          <a-menu-item class="footer-menu-item" v-if="VUE_APP_VERSION == 'hprt'">
            <a-button
              v-if="userMemberInfo.status != 1"
              @click="goToMember"
              shape="round"
              style="
                background: linear-gradient(97deg, #fce8c9 0%, #fccf8a 100%);
                color: #864510;
                border: none;
                height: 32px;
                margin-top: 4px;
                border-radius: 20px;
              "
              >{{ $t(`button.Upgrade`) }}</a-button
            >
            <div class="menu-member" v-else>
              <img
                style="width: 24px; height: 24px; margin-top: 8px"
                src="../../../static/icon/VIP.png"
                alt=""
              />
              <div class="member-text">
                {{ userMemberInfo.new_expire_time }}
              </div>
              <a-button
                @click="goToMember"
                shape="round"
                style="
                  background: linear-gradient(97deg, #fce8c9 0%, #fccf8a 100%);
                  color: #864510;
                  border: none;
                  height: 32px;
                  margin-top: 4px;
                "
                >{{ $t(`button.Renewal`) }}</a-button
              >
            </div>
          </a-menu-item>
          <a-menu-item class="footer-menu-item">
            <router-link to="/user">{{ $t(`navbar.user`) }}</router-link>
          </a-menu-item>
          <a-sub-menu key="1" class="footer-menu-item">
            <template #title>{{ language }}</template>
            <a-menu-item key="zh" class="footer-menu-item">{{
              $t(`lang.chinese`)
            }}</a-menu-item>
            <a-menu-item key="en" class="footer-menu-item">{{
              $t(`lang.english`)
            }}</a-menu-item>
            <a-menu-item key="pt" class="footer-menu-item">{{
              $t(`lang.portuguese`)
            }}</a-menu-item>
            <a-menu-item key="es" class="footer-menu-item">{{
              $t(`lang.Spanish`)
            }}</a-menu-item>
            <a-menu-item key="ru" class="footer-menu-item">{{
              $t(`lang.Russian`)
            }}</a-menu-item>
          </a-sub-menu>
          <a-sub-menu key="2" class="footer-menu-item">
            <template #title>{{ $t(`navbar.unit`) }}：{{ unit }}</template>
            <a-menu-item key="Mm" class="footer-menu-item">Mm</a-menu-item>
            <a-menu-item key="Inch" class="footer-menu-item">Inch</a-menu-item>
          </a-sub-menu>
          <a-menu-item @click="logout" class="footer-menu-item">
            <span style="color: #f73e3e">{{ $t(`navbar.logout`) }}</span>
          </a-menu-item>
        </a-sub-menu>
        <a-menu-item :key="'login'" v-else>
          <router-link to="/login">
            <user-outlined />
            <span>{{ $t(`navbar.login`) }}</span>
          </router-link>
        </a-menu-item>
      </a-menu>
    </a-layout-footer>
  </a-layout>
  <Suggest ref="suggestRef" />
</template>

<script>
import { removeAuthorization } from "@/utils/request";
import { getSign } from "@/utils/signature";
import { formatTime } from "@/utils/formatTime";
import { UserOutlined } from "@ant-design/icons-vue";

import {
  defineComponent,
  getCurrentInstance,
  reactive,
  toRefs,
  ref,
  onMounted,
  nextTick,
  watch,
} from "vue";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";
import Suggest from "../Suggest.vue";

export default defineComponent({
  components: {
    UserOutlined,
    Suggest,
  },

  setup() {
    const store = useStore();
    const { proxy } = getCurrentInstance();
    let globalProperties = getCurrentInstance().appContext.config.globalProperties;
    const axios = globalProperties.$axios;
    const axioshanma = globalProperties.$axioshanma;
    const router = useRouter();
    const route = useRoute();
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    const state = reactive({
      footerSelectedKeys: [],
      language: "",
      unit: globalProperties.$unit,
      collapsed: false,
      suggestRef: null,
      isMember: false,
      userData: [],
      userMemberInfo: [],
      VUE_APP_VERSION: process.env.VUE_APP_VERSION,
      webUrl: [],
    });
    watch(
      () => store.getters.getUser,
      () => {
        state.userData.head_pic = store.getters.getUser.avatar;
        state.userData.nickname = store.getters.getUser.name;
      }
    );
    watch(
      () => store.getters.getMemberInfo,
      () => {
        state.userMemberInfo = store.getters.getMemberInfo;
        state.userMemberInfo.new_expire_time = formatTime(
          state.userMemberInfo.expire_time
        );
      }
    );
    watch(
      () => proxy.$i18n.locale,
      () => {
        state.userMemberInfo.new_expire_time = formatTime(
          state.userMemberInfo.expire_time
        );
      }
    );

    onMounted(() => {
      var localeLanguage = localStorage.getItem("language");
      var type = "";
      if (localeLanguage) {
        type = localeLanguage;
        proxy.$i18n.locale = localeLanguage;
      } else {
        type = proxy.$i18n.locale;
      }
      switch (type) {
        case "zh":
          state.language = "简体中文";
          break;
        case "en":
          state.language = "English";
          break;
        case "pt":
          state.language = "Português";
          break;
        case "es":
          state.language = "Español";
          break;
        case "ru":
          state.language = "Русский язык";
          break;
        default:
          state.language = "简体中文";
      }
      getPlatformList();
      getUserInfo();
      getMemberUser();
      let openSuggest = localStorage.getItem("openSuggest");
      if (openSuggest == "true") {
        nextTick(() => {
          setTimeout(() => {
            state["suggestRef"].show("pc");
            localStorage.removeItem("openSuggest");
          }, 1000);
        });
      }
    });
    const getPlatformList = () => {
      state.webUrl = [];
      axioshanma("/api/tem.web_api/getPlatformList").then((res) => {
        res.map((item) => {
          let obj = {
            url: item.address,
            title: item.translate_name,
            name: item.name,
            target: "_blank",
          };
          state.webUrl.push(obj);
        });
      });
    };
    const getUserInfo = () => {
      var timestamp = Date.parse(new Date());
      timestamp = timestamp / 1000;
      let param = {
        timestamp,
        fun: "hmUserInfo",
        requestType: "User",
        appId: "a0f0e723-f2bb-11e8-bc50-00163e0c395e",
        appKey: "a0f12ce4-f2bb-11e8-bc50-00163e0c395e",
        userId: userInfo.userid,
      };
      var signature = getSign(param);
      let obj = JSON.parse(JSON.stringify(param));
      obj.signature = signature;
      axios("/api/apiservice/apiroute", obj).then((res) => {
        state.userData = res;
      });
    };
    const getMemberUser = () => {
      axioshanma("/api/tem.app_member/getMemberUser", {
        user_id: userInfo.userid,
      }).then((res) => {
        state.userMemberInfo = res;
        state.userMemberInfo.new_expire_time = formatTime(
          state.userMemberInfo.expire_time
        );
      });
    };

    const goToMember = () => {
      router.push("/member");
    };
    const getCollapsed = (val) => {
      state.collapsed = val;
    };

    const handleClick = (e) => {
      if (e.keyPath[1] == "1") {
        let type = e.key;
        proxy.$i18n.locale = type;
        proxy.$root.getLanguage();
        if (type == "zh") {
          state.language = "简体中文";
        } else if (type == "en") {
          state.language = "English";
        } else if (type == "pt") {
          state.language = "Português";
        } else if (type == "es") {
          state.language = "Español";
        } else if (type == "ru") {
          state.language = "Русский язык";
        }
        // console.log(proxy.$i18n.locale);
        localStorage.setItem("language", proxy.$i18n.locale);
        getPlatformList();
      } else if (e.keyPath[1] == "2") {
        let type = e.key;
        globalProperties.$unit = type;
        state.unit = globalProperties.$unit;
      }
    };
    const changeUnit = () => {
      state.unit = globalProperties.$unit;
    };
    const logout = () => {
      localStorage.removeItem("userInfo");
      removeAuthorization();
      router.push("/login");
    };
    const handleSuggest = () => {
      nextTick(() => {
        state["suggestRef"].show();
      });
    };

    const handleHereOpen = (val) => {
      if (process.env.VUE_APP_VERSION == "hprt") {
        if (proxy.$i18n.locale == "zh") {
          window.open(val, "_blank");
        } else {
          window.open("/en" + val, "_blank");
        }
      } else {
        window.open(val, "_blank");
      }
    };

    const handleOpenWeb = (val) => {
      window.open(val.url, "_blank");
    };
    return {
      ...toRefs(state),
      handleClick,
      userInfo,
      logout,
      changeUnit,
      goToMember,
      getCollapsed,
      handleSuggest,
      handleHereOpen,
      handleOpenWeb,
      formatTime,
    };
  },
});
</script>

<style scoped>
.sider-content-box {
  background: #fff;
}
.sider-content-box ::v-deep(.ant-layout-content) {
  background: #fff;
  display: block;
  margin-top: 32px;
  height: calc(100vh - 96px - 32px - 72px - 15px);
  overflow: hidden;
  overflow-y: auto;
}
.sider-content-box ::v-deep(.ant-layout-footer) {
  padding: 0;
  position: absolute;
  bottom: 15px;
  width: 100%;
  background: #fff;
}

.sider-content-box ::v-deep(.ant-menu-vertical > .ant-menu-item) {
  width: 100%;
  height: 72px;
  line-height: 72px;
  font-size: 16px;
  padding-left: 16px;
  margin: 0;
  padding-left: 20px;
}
.sider-content-box ::v-deep(.ant-menu-vertical .ant-menu-item:not(:last-child)) {
  margin-bottom: 0;
}

.sider-content-box
  ::v-deep(.ant-menu-vertical > .ant-menu-submenu > .ant-menu-submenu-title) {
  height: 72px;
  line-height: 72px;
  font-size: 16px;
  margin: 0;
  display: flex;
  align-items: center;
}
.sider-content-box ::v-deep(.ant-menu-vertical .ant-menu-title-content) {
  width: 70%;
}

.sider-content-box
  ::v-deep(.ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected .menu-icon) {
  color: #003591;
}

.user-pic {
  width: 48px;
  height: 48px;
  border-radius: 50px;
  border: 1px solid #dedede;
  object-fit: cover;
}
.sider-footer ::v-deep(.ant-menu-vertical > .ant-menu-item) {
  width: 100%;
  height: 72px;
  line-height: 72px;
  font-size: 16px;
  margin: 0;
}

.ant-menu-item a {
  display: flex;
  align-items: center;
}

.menu-icon {
  font-size: 22px !important;
  color: #7b89a1;
  margin-right: 8px !important;
}

.menu-member {
  display: flex;
  align-content: center;
  justify-content: space-between;
  height: 40px;
  line-height: 40px;
}
.member-text {
  min-width: 100px;
  margin-left: 4px;
  margin-right: 4px;
}

@media only screen and (max-width: 1300px) {
  .sider-content-box ::v-deep(.ant-menu-vertical .ant-menu-title-content) {
    width: 50%;
  }
}
</style>
